import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'
import clsx from 'clsx'
import * as css from './TextMediaSection.module.css'

const TextMedia = ({ heading, _rawRichtext, image, videoUrl, cta, cta2, index }) => {
	let isEven = index % 2 == 0 ? true : false;

	return (
		<article className={`${css.sections} w-full flex <md:flex-col shrink-0 items-center justify-center gap-y-8 gap-x-12`}>
			<figure data-aos={isEven ? "fade-left" : "fade-right"} className="w-full md:max-w-[50%] lg:max-w-[60%]">
				{!!videoUrl
					? <iframe className="aspect-video w-full" src={videoUrl} />
					: <Img image={image} />
				}
			</figure>

			<div data-aos={isEven ? "fade-right" : "fade-left"} className={`${css.textSection} max-w-full md:max-w-[50%] lg:max-w-[40%] richtext-lg`}>
				<HTag className="h1" {...heading} />
				<Richtext raw={_rawRichtext} />
				<p className="flex flex-wrap items-center gap-2 md:gap-4">
					<CTA {...cta} />
					<CTA {...cta2} />
				</p>
			</div>
		</article>
	)
}

const TextMediaSection = ({ accent, pattern, items, blockId }) => {
	const style =
		accent === '#FFC28B' ? 'bg-orange-light' :
		accent === '#FFC42F' ? 'bg-sunshine' :
		accent === '#E4F9FA' ? 'bg-light-blue' :
		accent === '#F7E9D4' ? 'bg-tan text-orange' :
		accent === '#0F2938' ? 'bg-grounding-navy text-white' :
		accent === '#7FC7C5' ? 'bg-caribbean' :
		'bg-orange text-white'

	return (
		<section id={blockId} className={clsx(style, pattern)}>
			<div className="section grid gap-20 <md:gap-12">
				{items?.map((item, key) => (
					<TextMedia {...item} index={key} key={key} />
				))}
			</div>
		</section>
	)
}

export default TextMediaSection
